import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AuditLogResponse, AuditLogsRequestParams } from "../../auditLog.types";
import { requestGetAuditLogs } from "./getAuditLogs.request";

const useGetAuditLogs = (
  requestParams: AuditLogsRequestParams,
  options?: QueryOptions<
    GetListResponse<AuditLogResponse>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["audit-logs", "admin", "all", requestParams],
    queryFn: async () => await requestGetAuditLogs(requestParams),
    onError: toastServerError,
    ...options
  });

  return { auditLogs: data?.data, meta: data?.meta, ...rest };
};

export default useGetAuditLogs;
